import * as consts from '../../constants.js';

export default {
  dataWorkEquipmentStatus: consts.REQUEST_WITHOUT_STARTING,
  workEquipment: [],
};
